<!-- 一般的な券種 パスが有効化され、期限内であり残り時間が00:00以外であれば有効なアニメーションを表示 -->
<template>
  <div class="footer">
    <!-- カウントダウン表示(一部チケットのみ) -->
    <FaceCountDown :countDown="props.countDown" v-if="isCountdownType" />

    <!-- QR改札(QR+＋アニメーション) -->
    <FaceAnimationAndQR
      v-if="isQrTicketGate"
      :animationUrl="pass.pass_animation_image_url || String()"
      :isValidQrString="isValidQrForQrTicketGate"
      :qrString="
        qrInfoForQrTicketGate == null ? '' : qrInfoForQrTicketGate.qrcode_string
      "
      :onTapReload="onTapReload"
    />

    <!-- QR改札以外(QRのみ or アニメーションのみ) -->
    <div v-else>
      <!-- QR(サンリオ) -->
      <PFaceQRLink v-if="isQrPass" :qrString="qrString" />

      <PFaceOldQRLink v-else-if="isOldQrPass" :qrLink="qrLink" />

      <!-- アニメーション -->
      <FaceAnimation v-else :url="pass.pass_animation_image_url || String()" />
    </div>
  </div>

  <!-- ローディングダイアログ -->
  <DialogLoading ref="DialogLoading" />
</template>

<script>
import { onMounted, computed, ref, watchEffect } from "vue";
import { useStore } from "vuex";

import API from "@/API";

import passService from "@/services/pass";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "ThePassLowerAfterValid",
  props: {
    countDown: {
      type: String,
    },
    updatePassForQrTicketGate: {
      type: Function,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();

    const pass = computed(() => store.getters["ticketing/pass"]);
    const masterPass = computed(() => store.getters["ticketing/masterPass"]);

    const DialogLoading = ref(null);

    const isCountdownType = computed(() =>
      passService.checkIsCountdownPass(masterPass.value)
    );

    // QRチケット用
    const isQrPass = passService.checkIsQrPass(masterPass.value);
    const qrString = ref(null);

    // 旧QRチケット用(2022.4までのサンリオ 終売後削除予定)
    const isOldQrPass = passService.checkIsOldQrPass(masterPass.value);
    const qrLink = ref(null);

    // QR改札用
    const isQrTicketGate = computed(() =>
      passService.checkIsQrTicketGate(pass.value)
    );
    const qrInfoForQrTicketGate = ref(null);
    const isValidQrForQrTicketGate = ref(null);
    const interval = ref(null);

    const getQrInfo = async () => {
      // リロード時など、intervalが動いていればクリア
      if (interval.value != null) {
        clearInterval(interval.value);
      }
      qrInfoForQrTicketGate.value = await API.getQrInfoForQrTicketGate(
        pass.value.id
      );

      // QRが有効かどうかをチェック(10秒周期)
      updateIsValidQrCode();
      interval.value = setInterval(() => updateIsValidQrCode(), 10 * 1000);
    };

    const updateIsValidQrCode = () => {
      isValidQrForQrTicketGate.value = passService.checkIsValidQrCode(
        qrInfoForQrTicketGate.value.limited_at
      );
    };

    // QRコードのステータスに応じて、画面の輝度を調整(有効な場合は明るく、無効な場合は戻す)
    const changeBrightnessOfScreen = (isValidQr) => {
      if (isValidQr) {
        nativeHandlerService.ncSetBrightnessMax();
      } else {
        nativeHandlerService.ncRevertBrightness();
      }
    };

    const onTapReload = async () => {
      // リロード時はAPIコール中にloading表示
      DialogLoading.value.openDialog();
      // pass情報取得
      await props.updatePassForQrTicketGate();
      // passが有効なら、QR情報取得
      if (!pass.value.is_expired) {
        await getQrInfo();
      }
      DialogLoading.value.closeDialog();
    };

    onMounted(async () => {
      try {
        // QRチケット(サンリオ)の場合
        if (isQrPass) {
          qrString.value = await API.getQrString(pass.value.id);
          nativeHandlerService.ncSetBrightnessMax();
        }
        // 旧QRチケット(サンリオ 2022.4まで)の場合
        else if (isOldQrPass) {
          qrLink.value = await API.getQrLink(pass.value.id);
          nativeHandlerService.ncSetBrightnessMax();
        }
        // QR改札チケットの場合
        else if (isQrTicketGate.value) {
          await getQrInfo();
        }
      } catch (e) {
        console.log(`Error in ThePassLowerAfterValid onMounted() :${e}`);
      }
    });

    watchEffect(() => {
      // QRステータスが変わった際は、画面輝度を変更
      if (isValidQrForQrTicketGate.value != null) {
        changeBrightnessOfScreen(isValidQrForQrTicketGate.value);
      }
    });

    return {
      qrInfoForQrTicketGate,
      qrLink,
      qrString,
      pass,
      masterPass,
      isCountdownType,
      isQrPass,
      isOldQrPass,
      isQrTicketGate,
      isValidQrForQrTicketGate,
      onTapReload,
      props,
      DialogLoading,
    };
  },
};
</script>
